import { render, staticRenderFns } from "./BlackGoldAgeRestriction.vue?vue&type=template&id=5886fb0e"
import script from "./BlackGoldAgeRestriction.vue?vue&type=script&lang=js"
export * from "./BlackGoldAgeRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports